(() => {
  if (window.arousseProductReady) return;
  window.arousseProductReady = true;
  const instances = new Map();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-premium-product]').forEach(root => {
      if (instances.has(root)) return;
      const listeners = new AbortController();
      const input = root.querySelector('input[name="quantity"]');
      const steps = [...root.querySelectorAll('[data-quantity-step]')];
      const limits = () => {
        const min = Number(input?.min || 1), step = Number(input?.step || 1);
        const rawMax = input?.max ? Number(input.max) : Infinity;
        return {min, step, max: Number.isFinite(rawMax) ? min + Math.floor((rawMax - min) / step) * step : Infinity};
      };
      const sync = () => {
        if (!input) return;
        const {min, max, step} = limits();
        steps.forEach(button => { button.disabled = Number(button.dataset.quantityStep) < 0 ? Number(input.value) <= min : Number(input.value) + step > max; });
      };
      const gallery = root.querySelector('[data-product-gallery]');
      let photos = [];
      try { photos = JSON.parse(gallery?.dataset.galleryPhotos || '[]'); } catch {}
      let current = Math.max(0, photos.findIndex(photo => String(photo.id) === gallery?.dataset.galleryStart));
      const showPhoto = index => {
        if (!photos.length) return;
        current = (index + photos.length) % photos.length;
        const photo = photos[current], image = root.querySelector('[data-main-image]');
        if (image) {
          image.srcset = photo.srcset || '';
          image.sizes = '(max-width: 800px) 92vw, 50vw';
          image.src = photo.src; image.alt = photo.alt || '';
          if (photo.width && photo.height) { image.width = photo.width; image.height = photo.height; }
        }
        const link = root.querySelector('[data-main-image-link]'); if (link) link.href = photo.full;
        root.querySelectorAll('[data-thumbnail]').forEach(thumb => { const selected = Number(thumb.dataset.photoIndex) === current; thumb.classList.toggle('is-active', selected); thumb.setAttribute('aria-pressed', String(selected)); });
        const counter = root.querySelector('[data-photo-position]'); if (counter) counter.textContent = String(current + 1);
      };
      gallery?.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('video, model-viewer, iframe')) return;
        if (photos.length < 2) return;
        event.preventDefault(); showPhoto(current + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal: listeners.signal});
      root.addEventListener('click', event => {
        const arrow = event.target.closest('[data-photo-step]'); if (arrow) { event.preventDefault(); showPhoto(current + Number(arrow.dataset.photoStep)); }
        const photo = event.target.closest('[data-thumbnail]'); if (photo) showPhoto(Number(photo.dataset.photoIndex));
        const button = event.target.closest('[data-quantity-step]');
        if (button && input) {
          const {min, max, step} = limits();
          if (max < min) return;
          const value = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
          const aligned = min + Math.round((value - min) / step) * step;
          input.value = String(Math.max(min, Math.min(max, aligned + Number(button.dataset.quantityStep) * step)));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }, {signal: listeners.signal});
      input?.addEventListener('input', sync, {signal: listeners.signal});
      input?.addEventListener('change', sync, {signal: listeners.signal});
      root.querySelector('select[name="id"]')?.addEventListener('change', event => {
        const url = new URL(location.href); url.searchParams.set('variant', event.target.value); location.assign(url.toString());
      }, {signal: listeners.signal});
      const counter = root.querySelector('[data-photo-position]'); if (counter && photos.length) counter.textContent = String(current + 1);
      sync();
      instances.set(root, () => listeners.abort());
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, destroy] of instances) if (event.target.contains(root)) { destroy(); instances.delete(root); } });
})();
